<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ getTitle() }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [disabled]="this.task.title.trim() ==''" [strong]="true"
        data-cy="save-task-button">{{ 'common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="app-page-container">

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'task.form.detailsSection' | translate }}</h3>
      </header>

      <ion-item lines="none" class="form-item">
        <ion-label mode="ios" position="stacked">{{ 'task.form.titleLabel' | translate }}</ion-label>
        <ion-input [(ngModel)]="task.title" class="custom" data-cy="add-task-title-input"
          [placeholder]="'task.form.titlePlaceholder' | translate" />
      </ion-item>

      <ion-item lines="none" class="form-item">
        <ion-label mode="ios" position="stacked">{{ 'task.form.descriptionLabel' | translate }}</ion-label>
        <ion-textarea [(ngModel)]="task.description" autocapitalize="sentences" class="custom"
          data-cy="add-task-description-input" enterkeyhint="next" inputmode="text"
          [placeholder]="'task.form.descriptionPlaceholder' | translate" rows="8"
          maxlength="2000" counter="true"
          spellcheck="true" />
      </ion-item>
    </section>

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'task.form.propertiesSection' | translate }}</h3>
      </header>

      <ion-item lines="none" class="form-item">
        <ion-label mode="ios" position="stacked">{{ 'task.form.priorityLabel' | translate }}</ion-label>
        <ion-select [(ngModel)]="task.priority" data-cy="add-task-priority-input">
          <ion-select-option [value]="priority.VeryHigh">{{ 'priority.veryHigh' | translate }}</ion-select-option>
          <ion-select-option [value]="priority.High">{{ 'priority.high' | translate }}</ion-select-option>
          <ion-select-option [value]="priority.Medium">{{ 'priority.medium' | translate }}</ion-select-option>
          <ion-select-option [value]="priority.Low">{{ 'priority.low' | translate }}</ion-select-option>
          <ion-select-option [value]="priority.VeryLow">{{ 'priority.veryLow' | translate }}</ion-select-option>
        </ion-select>
      </ion-item>
    </section>

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'task.form.imagesSection' | translate }}</h3>
      </header>

      <app-picture-picker
        [(imageIds)]="task.imageIds"
        [(removedImageIds)]="task.removedImageIds"
        [existingImages]="task.images"
        [maxNumberImages]="64"
        class="w-100p" />
    </section>

    <div class="submit-row">
      <ion-button (click)="cancel()" fill="outline">{{ 'common.cancel' | translate }}</ion-button>
      <ion-button (click)="confirm()" [disabled]="this.task.title.trim() ==''" [strong]="true"
        data-cy="save-task-button" color="primary">{{ 'common.save' | translate }}</ion-button>
    </div>

  </div>
</ion-content>
